import jsPDF from 'jspdf';

export async function exportInterconsultaPDF({ paciente, orden, doctor, imprimir = false }) {
  const doc = new jsPDF({ unit: 'pt', format: 'letter' });
  const pw = doc.internal.pageSize.getWidth();
  const ph = doc.internal.pageSize.getHeight();
  const m = 28;
  let y = m;

  const hoy = new Date().toLocaleDateString('es', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const calcEdad = (iso) => {
    if (!iso) return '—';
    return Math.floor((Date.now() - new Date(iso).getTime()) / (365.25 * 24 * 3600 * 1000));
  };
  const fmtFechaNac = (iso) => {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString('es', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  const edad = calcEdad(paciente?.fecha_nacimiento);
  const fechaNac = fmtFechaNac(paciente?.fecha_nacimiento);
  const nombrePaciente = (paciente?.nombre_completo || '—').toUpperCase();
  const sexo = paciente?.sexo === 'femenino' ? 'Mujer' : paciente?.sexo === 'masculino' ? 'Hombre' : '—';

  const dr = {
    nombre: doctor?.nombre || 'Raul Olier',
    rfc: doctor?.rfc || 'OIPH650912881',
    especialidad1: doctor?.especialidad1 || 'Medicina General',
    cedula: doctor?.cedula || '3625181',
    universidad: doctor?.universidad || 'Universidad de Cartagena - Colombia',
    especialidad2: doctor?.especialidad2 || 'Maestría en Cirugía Estética',
    dgp: doctor?.dgp || '6698688',
  };

  let logoImg = null;
  let firmaImg = null;
  try {
    const toDataUrl = (url) => new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const c = document.createElement('canvas');
        c.width = img.width; c.height = img.height;
        c.getContext('2d').drawImage(img, 0, 0);
        resolve(c.toDataURL('image/png'));
      };
      img.onerror = () => resolve(null);
      img.src = url;
    });
    logoImg = await toDataUrl('/logo-nara-png.png');
    firmaImg = await toDataUrl('/firma_doctor.png');
  } catch (e) { /* sin imágenes */ }

  if (logoImg) doc.addImage(logoImg, 'PNG', 10, 8, 65, 65);

  const headerX = logoImg ? 80 : m;
  doc.setFontSize(8);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  doc.text('ORDEN DE INTERCONSULTA', headerX, m + 20);
  doc.setFontSize(8.5);
  doc.setTextColor(112, 112, 112);
  doc.setFont('helvetica', 'bold');
  doc.text('FECHA DE IMPRESIÓN:', headerX + 200, m + 20);
  doc.setTextColor(0, 0, 0);
  doc.text(` ${hoy}`, headerX + 200 + doc.getTextWidth('FECHA DE IMPRESIÓN:'), m + 20);

  y = m + 50;
  const labelVal = (label, val, yPos) => {
    doc.setTextColor(112, 112, 112);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8.5);
    doc.text(label, m, yPos);
    doc.setTextColor(0, 0, 0);
    const lines = doc.splitTextToSize(val, pw - m - doc.getTextWidth(label) - m - 4);
    doc.text(lines, m + doc.getTextWidth(label) + 4, yPos);
    return yPos + (lines.length * 11) + 2;
  };

  y = labelVal('Dr. ', dr.nombre, y);
  y = labelVal('RFC: ', dr.rfc, y);
  y = labelVal('Especialidad: ', `${dr.especialidad1}  Cédula: ${dr.cedula}  ${dr.universidad}`, y);
  y = labelVal('Especialidad: ', dr.especialidad2, y);
  y = labelVal('D.G.P. ', dr.dgp, y);
  y += 5;

  doc.setDrawColor(180, 180, 180);
  doc.setLineWidth(0.5);
  doc.line(m, y, pw - m, y);
  y += 12;

  doc.setFontSize(8.5);
  doc.setTextColor(112, 112, 112);
  doc.setFont('helvetica', 'bold');
  doc.text('Nombre del paciente', m, y);
  doc.text('Edad', pw / 2 + 40, y);
  y += 14;

  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'bold');
  doc.text(nombrePaciente, m + 4, y);
  doc.setFontSize(8.5);
  doc.text(`${edad} años (${sexo})${fechaNac ? ` · ${fechaNac}` : ''}`, pw / 2 + 40, y);
  y += 18;

  doc.setDrawColor(200, 200, 200);
  doc.setLineWidth(0.3);
  doc.line(m, y, pw - m, y);
  y += 18;

  // Contenido de la interconsulta
  const contenido = orden?.contenido || {};

  doc.setFontSize(8.5);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  doc.text(`Interconsulta a: ${contenido.especialidad || '—'}`, m, y);
  y += 18;

  // Datos del especialista si existen
  if (contenido.nombre_especialista || contenido.telefono_especialista) {
    doc.setFontSize(8.5);
    doc.setTextColor(112, 112, 112);
    doc.setFont('helvetica', 'bold');
    if (contenido.nombre_especialista) {
      y = labelVal('Especialista: ', contenido.nombre_especialista, y);
    }
    if (contenido.telefono_especialista) {
      y = labelVal('Teléfono: ', contenido.telefono_especialista, y);
    }
    y += 5;
  }

  // Motivo
  if (contenido.motivo) {
    doc.setFontSize(8.5);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(112, 112, 112);
    doc.text('Motivo de la referencia:', m, y);
    y += 14;
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    const lines = doc.splitTextToSize(contenido.motivo, pw - m * 2);
    for (const line of lines) {
      if (y > ph - 120) { doc.addPage(); y = m; }
      doc.text(line, m, y);
      y += 12;
    }
    y += 12;
  }

  // Cierre
  doc.setFontSize(8.5);
  doc.setFont('helvetica', 'normal');
  doc.text('Agradezco la atención brindada a mi paciente.', m, y);
  y += 14;
  doc.text(`Médico tratante:  ${dr.nombre}`, m, y);
  y += 12;
  doc.text(`Especialidad: ${dr.especialidad1} Ced. Esp.: ${dr.cedula}`, m, y);

  // Footer
  const numPaginas = doc.internal.getNumberOfPages();
  for (let i = 1; i <= numPaginas; i++) {
    doc.setPage(i);
    const footerY = ph - 55;
    if (firmaImg) doc.addImage(firmaImg, 'PNG', pw - m - 130, footerY - 30, 120, 60);
    doc.setDrawColor(180, 180, 180);
    doc.setLineWidth(0.5);
    doc.line(pw / 2 - 60, footerY + 10, pw - m, footerY + 10);
    doc.setFontSize(8.5);
    doc.setTextColor(112, 112, 112);
    doc.setFont('helvetica', 'bold');
    doc.text('Dr. ', pw / 2 - 60, footerY + 22);
    doc.setTextColor(0, 0, 0);
    doc.text(dr.nombre, pw / 2 - 60 + doc.getTextWidth('Dr. ') + 2, footerY + 22);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(112, 112, 112);
    doc.text('  |  Firma:', pw / 2 - 60 + doc.getTextWidth('Dr. ') + 2 + doc.getTextWidth(dr.nombre), footerY + 22);
    doc.setFontSize(8.5);
    doc.setTextColor(0, 0, 0);
    doc.setFont('helvetica', 'bold');
    doc.text(`pág ${i} - ${numPaginas}`, m, footerY + 22);
  }

  if (imprimir) {
    doc.autoPrint();
    window.open(doc.output('bloburl'), '_blank');
  } else {
    const nombre = (paciente?.nombre_completo || 'paciente').replace(/\s+/g, '_');
    doc.save(`interconsulta_${contenido.especialidad || ''}_${nombre}_${Date.now()}.pdf`);
  }
}
